import { IAlertMessage } from "@pulse-ui/types/components/AlertMessage";
import { useState, useCallback } from "react";

export interface AlertMessage {
  id: string;
  message: string;
  status: number;
  onClickText?: string;
  onClickMethod?: () => void;
}

export const useAlert = () => {
  const [alerts, setAlerts] = useState<AlertMessage[]>([]);

  const pushAlert = useCallback((alert: IAlertMessage) => {
    setAlerts((prevAlerts) => [...prevAlerts, { ...alert }]);
  }, []);

  const closeAlert = useCallback((id: string) => {
    setAlerts((prevAlerts) => prevAlerts.filter((alert) => alert.id !== id));
  }, []);

  const clearAlerts = useCallback(() => {
    setAlerts([]);
  }, []);

  return {
    alerts,
    pushAlert,
    closeAlert,
    clearAlerts,
  };
};
